import { transliterate } from "@/utils/translitUtils";

/**
 * Приводит пользовательское название к идентификатору, который можно безопасно
 * использовать и как API-code, и как имя переменной в формуле.
 */
export function generateCode(name) {
  const normalized = transliterate(String(name || "").trim())
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");

  if (!normalized) return "code";
  return /^[a-z_]/.test(normalized) ? normalized : `code_${normalized}`;
}

/**
 * Возвращает уникальный код на основе имени, добавляя суффикс _1, _2 ...
 * Поддерживает:
 *  - existing = массив строк кодов
 *  - existing = массив записей с полями { id, code }
 * Параметр excludeId применяется только если переданы записи с id.
 */
export function generateUniqueCode(
  name,
  existing = [],
  excludeId = null
) {
  const baseCode = generateCode(name);
  let code = baseCode;
  let suffix = 1;

  // Нормализуем список существующих кодов
  let existingCodes = [];
  if (Array.isArray(existing)) {
    if (existing.length === 0) {
      existingCodes = [];
    } else if (typeof existing[0] === "string") {
      existingCodes = existing;
    } else if (
      typeof existing[0] === "object" &&
      existing[0] !== null
    ) {
      const records =
        excludeId == null
          ? existing
          : existing.filter((rec) => rec.id !== excludeId);
      existingCodes = records.map((rec) => rec.code);
    }
  }

  // Добавляем суффикс, если такой код уже есть
  while (existingCodes.includes(code)) {
    code = `${baseCode}_${suffix}`;
    suffix++;
  }

  return code;
}
